import { apiClient } from './client';

export interface ReferralMe {
  code: string;
  link: string;
  referrals: number;
  bonus: string;
  alreadyReferred: boolean;
}

export const referralApi = {
  me: () => apiClient.get<ReferralMe>('/referral/me').then((r) => r.data),
  apply: (code: string) =>
    apiClient
      .post<{ applied: boolean; bonus: string; newBalance: string }>('/referral/apply', { code })
      .then((r) => r.data),
};
